import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { getRefundDetails } from '../../../services/direct';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/payments/_authenticated/thank-you')({
  component: ThankYou,
});

function ThankYou() {
  const { t } = useTranslation();

  const refundDetailsQuery = useQuery({
    queryKey: ['refundDetails'],
    queryFn: async () => {
      const res = await getRefundDetails();

      sessionStorage.removeItem('token');
      return res;
    },
    enabled: false,
  });
  const { data } = refundDetailsQuery;

  useEffect(() => {
    refundDetailsQuery.refetch();
  }, []);

  const payment_type = data?.refundData?.refund_method;
  const refundAmount = data?.refundData?.refund_amount;
  const trans_id = data?.refundData?.transaction_id;
  const charityName = data?.refundData?.additional_info;

  return (
    <div className='relative flex h-full w-full flex-col items-center justify-center gap-4 text-center'>
      <div
        className='absolute inset-0 bg-cover bg-no-repeat dark:invert'
        style={{
          backgroundImage: 'url(/confetti_bg.png)',
        }}
      ></div>
      <div className='relative z-10 max-w-[550px] text-muted-foreground'>
        <h2 className='mb-2 text-4xl font-semibold text-foreground'>
          {t('Your Payment has been Initiated')}
        </h2>

        {data?.refundData?.email && (
          <h3 className='mb-4 text-center text-balance text-secondary-foreground'>
            {' '}
            {t('Please check')} <strong>{data?.refundData?.email}</strong>{' '}
            {t('for confirmation')}.{' '}
          </h3>
        )}

        {payment_type ? (
          payment_type === 6 ? (
            <div>
              {t(
                'Thank you for using Client Pay Direct. Your funds will be donated to the below charity',
              )}
              .
              <br />
              <p>
                {t('Charity name')}:<b>{charityName}</b> <br />
              </p>
              <p>
                {t('Amount')}: <b>{'$' + refundAmount}</b> <br />
              </p>
              <p>
                {t('Confirmation number')}: <b>{trans_id}</b>
              </p>
              <br />
              <p>
                <b>
                  {t('Please print / save this page for your tax records')}.
                </b>
              </p>
            </div>
          ) : payment_type === 7 ? (
            <p>
              {t('thank you for using cpd', { trans_id })}
              <a href='mailto:hello@clientpaydirect.com'>
                <strong> hello@clientpaydirect.com</strong>
              </a>
              .
            </p>
          ) : payment_type === 4 ? (
            <p>
              {t('thank you for using cpd giftcard')}
              <a href='mailto:hello@clientpaydirect.com'>
                <strong> hello@clientpaydirect.com</strong>
              </a>
              .
            </p>
          ) : (
            <p>
              {t(
                'Thank you for using Client Pay Direct. Your funds have been sent to you via',
              )}{' '}
              <b>
                {payment_type == 2
                  ? t('Paypal')
                  : payment_type == 3
                    ? t('Venmo')
                    : payment_type == 5
                      ? t('Check')
                      : payment_type == 4
                        ? t('Gift Card')
                        : payment_type == 6
                          ? t('Charity')
                          : payment_type == 7
                            ? t('Direct Deposit')
                            : null}
              </b>
              .
              {t(
                'You will receive an email confirmation shortly. If you have any questions, please write us at',
              )}{' '}
              <a href='mailto:hello@clientpaydirect.com'>
                <strong>hello@clientpaydirect.com</strong>
              </a>
              .
            </p>
          )
        ) : (
          ''
        )}
      </div>
    </div>
  );
}
